import React, { FC, ReactNode } from 'react'
import { Flex, FlexProps, PositionProps } from '@chakra-ui/react'

export type StickyProps = {
  children: ReactNode
  position: PositionProps
} & Omit<FlexProps, 'position'>

export const Sticky: FC<StickyProps> = ({
  children,
  position,
  ...flexProps
}) => (
  <Flex position="sticky" {...position} {...flexProps}>
    {children}
  </Flex>
)
